// extracted by mini-css-extract-plugin
export default {"paper":"Profile_paper__0NJ8O"};